import React, { useEffect } from "react";

import { Badge, Button, makeStyles } from "@fluentui/react-components";

import { Chat24Filled } from "@fluentui/react-icons";
import FluentChatOverlayContainer from "./FluentChatOverlayContainer";
import { useCssBreakpoints } from "react-use-css-breakpoints";
import { useSocialContext } from "../contexts/SocialContext";
import PropTypes from "prop-types";

const useStyles = makeStyles({
  button: {
    height: "40px",
    minWidth: "40px",
    backgroundColor: "var(--toolbar-overlay-background)",
    "& span": {
      width: "24px",
      height: "24px",
      fontSize: "24px"
    },
    "& svg": {
      color: "var(--color-text-primary)",
      fill: "var(--color-text-primary)"
    }
  },
  buttonActive: {
    backgroundColor: "var(--primaryColorBackground)",
    height: "40px",
    minWidth: "40px",
    "& span": {
      width: "24px",
      height: "24px",
      fontSize: "24px"
    },
    "& svg": {
      color: "var(--color-text-primary)",
      fill: "var(--color-text-primary)"
    }
  }
});

export default function ToolbarChatButton({
  toggleChat,
  isOpenChat,
  isOpenParticipants,
  selectedUser,
  closeChat,
  canOpenChat,
  canSendChat,
  ...rest
}) {
  const styles = useStyles();
  const breakpoint = useCssBreakpoints();
  const { publicUnreadMessages } = useSocialContext();

  useEffect(() => {
    if (!canOpenChat && isOpenChat) {
      closeChat?.();
    }
  }, [canOpenChat, closeChat, isOpenChat]);

  if (!canOpenChat) {
    return null;
  }

  return (
    <>
      <FluentChatOverlayContainer
        isOpenChat={isOpenChat}
        isOpenParticipants={isOpenParticipants}
        closeChat={closeChat}
        selectedUser={selectedUser}
        canSendChat={canSendChat}
        {...rest}
      ></FluentChatOverlayContainer>

      {!["xs", "sm", "md"].includes(breakpoint) && (
        <div style={{ position: "relative" }}>
          <Button
            appearance="subtle"
            onClick={() => toggleChat(!isOpenChat)}
            className={isOpenChat ? styles.buttonActive : styles.button}
            icon={<Chat24Filled />}
          />
          {publicUnreadMessages && <Badge size="small" style={{ position: "absolute", top: "-3px", right: "-3px" }} />}
        </div>
      )}
    </>
  );
}

ToolbarChatButton.propTypes = {
  toggleChat: PropTypes.func.isRequired,
  isOpenChat: PropTypes.bool.isRequired,
  isOpenParticipants: PropTypes.bool.isRequired,
  selectedUser: PropTypes.object,
  closeChat: PropTypes.func,
  canOpenChat: PropTypes.bool,
  canSendChat: PropTypes.bool
};
